var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: "onSubFormRowAdd", "label-width": "150px" } },
    [
      _c(
        "el-button",
        {
          attrs: { type: "info", icon: "el-icon-edit", plain: "", round: "" },
          on: {
            click: function ($event) {
              return _vm.editEventHandler("onSubFormRowAdd", _vm.eventParams)
            },
          },
        },
        [
          _vm._v(
            "\n    " + _vm._s(_vm.i18nt("designer.setting.addEventHandler"))
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }